import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import frCommon from '@/locales/fr/common.json';
import frAuth from '@/locales/fr/auth.json';
import frNavigation from '@/locales/fr/navigation.json';
import frDashboard from '@/locales/fr/dashboard.json';
import frTraining from '@/locales/fr/training.json';
import frGolf from '@/locales/fr/golf.json';
import frSupervision from '@/locales/fr/supervision.json';
import frPrivacy from '@/locales/fr/privacy.json';
import frAiAnalysis from '@/locales/fr/ai-analysis.json';
import frSubscription from '@/locales/fr/subscription.json';
import frResults from '@/locales/fr/results.json';
import frCourseStats from '@/locales/fr/course-stats.json';
import frPresentation from '@/locales/fr/presentation.json';
import enCommon from '@/locales/en/common.json';
import enAuth from '@/locales/en/auth.json';
import enNavigation from '@/locales/en/navigation.json';
import enDashboard from '@/locales/en/dashboard.json';
import enTraining from '@/locales/en/training.json';
import enGolf from '@/locales/en/golf.json';
import enSupervision from '@/locales/en/supervision.json';
import enPrivacy from '@/locales/en/privacy.json';
import enAiAnalysis from '@/locales/en/ai-analysis.json';
import enSubscription from '@/locales/en/subscription.json';
import enResults from '@/locales/en/results.json';
import enCourseStats from '@/locales/en/course-stats.json';
import enPresentation from '@/locales/en/presentation.json';
import esCommon from '@/locales/es/common.json';
import esAuth from '@/locales/es/auth.json';
import esNavigation from '@/locales/es/navigation.json';
import esDashboard from '@/locales/es/dashboard.json';
import esTraining from '@/locales/es/training.json';
import esGolf from '@/locales/es/golf.json';
import esSupervision from '@/locales/es/supervision.json';
import esPrivacy from '@/locales/es/privacy.json';
import esAiAnalysis from '@/locales/es/ai-analysis.json';
import esSubscription from '@/locales/es/subscription.json';
import esResults from '@/locales/es/results.json';
import esCourseStats from '@/locales/es/course-stats.json';
import esPresentation from '@/locales/es/presentation.json';

const resources = {
  fr: {
    common: frCommon,
    auth: frAuth,
    navigation: frNavigation,
    dashboard: frDashboard,
    training: frTraining,
    golf: frGolf,
    supervision: frSupervision,
    privacy: frPrivacy,
    'ai-analysis': frAiAnalysis,
    subscription: frSubscription,
    results: frResults,
    'course-stats': frCourseStats,
    presentation: frPresentation
  },
  en: {
    common: enCommon,
    auth: enAuth,
    navigation: enNavigation,
    dashboard: enDashboard,
    training: enTraining,
    golf: enGolf,
    supervision: enSupervision,
    privacy: enPrivacy,
    'ai-analysis': enAiAnalysis,
    subscription: enSubscription,
    results: enResults,
    'course-stats': enCourseStats,
    presentation: enPresentation
  },
  es: {
    common: esCommon,
    auth: esAuth,
    navigation: esNavigation,
    dashboard: esDashboard,
    training: esTraining,
    golf: esGolf,
    supervision: esSupervision,
    privacy: esPrivacy,
    'ai-analysis': esAiAnalysis,
    subscription: esSubscription,
    results: esResults,
    'course-stats': esCourseStats,
    presentation: esPresentation
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'auth', 'navigation', 'dashboard', 'training', 'golf', 'supervision', 'privacy', 'ai-analysis', 'subscription', 'results', 'course-stats', 'presentation'],
    
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },
  });

// Set default language to French if not already set (let i18n detector handle it)
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'fr');
}

export default i18n;